<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer"
         (click)="setTemplate(tile)">
        <floating-subtitle class="zone__name zone__name--tile font-22"
                           [text]="subtitle(tile.textNumber) || ''">
        </floating-subtitle>
    </div>

    <div class="zone__status cursor-pointer"
         (click)="setTemplate(tile)">
        <div class="gradient-zone zone__status-background"
             data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.relayState === 'on' }">
        </div>
    </div>

    <div class="zone__content cursor-pointer"
         (click)="setTemplate(tile)">
        <div *ngIf="tile.state !== 'noCommunication' && tile.state !== 'waiting'">
            <div class="zone__content-icon zone__content-icon--contact">
                <icon [iconName]="'relay'"
                      data-testid="tile-icon-relay"
                      *ngIf="!views.isMobileView()"
                      [iconSize]="63"
                      [className]="'fill-icon-grey'">
                </icon>
                <icon [iconName]="'relay'"
                      *ngIf="views.isMobileView()"
                      data-testid="tile-icon-relay-mobile"
                      [iconSize]="50"
                      [className]="'zone__icon zone__icon--contact zone__icon--dark zone__icon--dark-id-icon fill-icon-grey'">
                </icon>
            </div>
        </div>
        <div class="zone__contact"
             data-testid="tile-value"
             *ngIf="tile.state !== 'noCommunication' && tile.state !== 'waiting'">
            <floating-subtitle
                    class="zone__current-temp zone__current-temp--medium zone__current-temp--relay"
                    [text]="subtitle(1447)"
                    *ngIf="tile.relayState === 'on'">
            </floating-subtitle>
            <floating-subtitle
                    class="zone__current-temp zone__current-temp--medium zone__current-temp--relay"
                    [text]="subtitle(924)"
                    *ngIf="tile.relayState === 'off'">
            </floating-subtitle>
        </div>
    </div>

    <div class="dropdown-list dropdown-list--grey"
         *ngIf="zones.valveDropdown.additionalContact && zones.valveDropdown.systemTileId === tile.id"
         (click)="zones.showHideDropdownList(0)"
         [ngStyle]="{ bottom: zones.valveDropdown.position.bottom, top: zones.valveDropdown.position.top }">
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(8309) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                         data-testid="signal-icon"
                         ngSrc="{{ zones.signalIcon({signalStrength: tile.signalStrength}) }}"
                         width="25" height="25" alt=""/>
                </p>
            </div>
        </div>
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(2830) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    <span *ngIf="tile.relayState === 'on'">{{ subtitle(1447) }}</span>
                    <span *ngIf="tile.relayState === 'off'">{{ subtitle(924) }}</span>
                </p>
            </div>
        </div>
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(814) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ zonesSystem.setWorkTypeSubtitle(tile.workType) }}
                </p>
            </div>
        </div>
    </div>

    <div class="zones-container-tile__footer zones-container-tile__footer--tile bg-gradient bg-gradient--zone"
         (click)="views.isMobileView() && setTemplate(tile)"
         [ngClass]="{ 'cursor-pointer': views.isMobileView() }">
        <div class="zones-container-tile__footer-icons zones-container-tile__footer-icons--center">
            <div class="zones-container-tile__footer-icons-wrapper"
                 *ngIf="tile.signalStrength >= 0 && tile.state !== 'noCommunication' && tile.state !== 'waiting'">
                <img class="zones-container-tile__icon zones-container-tile__icon--small"
                     data-testid="signal-icon"
                     ngSrc="{{zones.signalIcon({signalStrength: tile.signalStrength}, 'white')}}"
                     width="25" height="25" alt=""/>
            </div>
            <div class="zones-container-tile__footer-icons-wrapper zones-container-tile__footer-icons-wrapper--no-border"
                 [ngClass]="{ 'zones-container-tile__footer-icons-wrapper--active fill-icon fill-icon--white': tile.relayState === 'on' }"
                 *ngIf="!(tile.state === 'noCommunication' || tile.state === 'waiting')">
                <icon [iconName]="'relay'"
                      data-testid="relay-icon"
                      [className]="'zones-container-tile__icon'"
                      [iconSize]="views.isMobileView() ? 25 : 36">
                </icon>
            </div>
        </div>
        <div class="zone__settings bg-input bg-input--primary cursor-pointer zones-container-tile__icon--settings"
             (click)="zones.showHideDropdownList('additionalContact', 'systemTile', tile.id)"
             [ngClass]="{ 'bg-input--open': zones.valveDropdown.additionalContact && zones.valveDropdown.systemTileId === tile.id,
            'bg-input--primary': !(zones.valveDropdown.additionalContact && zones.valveDropdown.systemTileId === tile.id) }"
             title="{{subtitle(2972)}}">
            <icon [iconName]="'settings'"
                  data-testid="settings-icon"
                  [className]="'fill-icon fill-icon--white'"
                  [iconSize]="40">
            </icon>
        </div>
    </div>

    <div class="zone__alert zone__alert--tile bg-dark-shadow zone__alert--without-actuator"
         [ngClass]="{ 'cursor-default': tile.state === 'noCommunication' }"
         *ngIf="tile.state === 'noCommunication'">
        <div class="zone__alert-top"></div>
        <div class="zone__alert-wrapper">
            <p class="zone__alert-name font-18" data-testid="tile-alert">
                {{ subtitle(1808) }}
            </p>
            <svg width="50" height="50"
                 class="tile__svg--alarm-animation fill-alert">
                <text x="25" y="45" font-size="65" font-weight="bold"
                      text-anchor="middle">!
                </text>
            </svg>
        </div>
    </div>

    <div class="zone__alert zone__alert--tile bg-dark-shadow zone__alert--without-actuator"
         [ngClass]="{ 'cursor-default': tile.state === 'waiting' }"
         *ngIf="tile.state === 'waiting'">
        <div class="zone__alert-top"></div>
        <div class="zone__alert-wrapper zone__alert-wrapper--no-padding">
            <p class="zone__alert-name font-18"  data-testid="tile-alert">
                {{ subtitle(2310) }}
            </p>
        </div>
    </div>
</div>
